import { useEffect, useState } from 'react';
import { fetchHistory } from '../services/api';

export default function HistoryPage() {
  const [rows, setRows] = useState<any[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchHistory()
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(e => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  if (error) return <div className="error-msg">{error}</div>;
  if (loading) return <div className="loading">Chargement...</div>;

  return (
    <div className="card">
      <h3>Historique</h3>
      <div className="table-wrap" style={{ marginTop: 16 }}>
        <table>
          <thead>
            <tr><th>Date</th><th>Type</th><th>Établissement</th><th>Événement</th><th>Utilisateur</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--muted)' }}>Aucun événement</td></tr>}
            {rows.map((r, i) => (
              <tr key={i}>
                <td>{r.date || r.created_at || '–'}</td>
                <td>{r.type || r.event_type || '–'}</td>
                <td>{r.establishment_name || r.hotel_name || '–'}</td>
                <td>{r.event || r.description || '–'}</td>
                <td>{r.user || r.user_name || '–'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
